<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !selectStatus}"
          @click="selectStatus =! selectStatus"
        />
        <el-input-number
          v-model.number="value"
          controls-position="right"
          :min="min"
          :max="max"
          type="number"
          :step="step"
          :disabled="!selectStatus"
          @change="changeOption"
        />
      </div>
      <el-checkbox
        v-model="selectStatus"
        class="control__checkbox"
        @change="changeOption"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'NumberInput',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: [Number, String],
      default: 0
    },
    hint: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 0
    },
    status: {
      type: Boolean
    },
    parameter: {
      type: String,
      default: ''
    },
    eventClick: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: this.default,
      selectStatus: this.status,
      showHint: false
    }
  },
  emits: ['changeOption'],
  computed: {
    ...mapState(['clearOptions'])
  },
  watch: {
    clearOptions (value) {
      if (value) {
        this.selectStatus = false
        this.value = this.default
      }
    },
    eventClick (val) {
      this.selectStatus = val
      this.value = this.default
    },
    selectStatus (val) {
      if (val === true) {
        this.changeOption()
      }
    },
  },
  methods: {
    changeOption () {
      const value = this.selectStatus === true ? `${this.value}` : ''
      this.$emit('changeOption', {
        parameter: `${this.parameter}`,
        separator: ':',
        value: value
      })
    }
  }
}
</script>
<style lang="scss">
.el-input-number.is-controls-right {
  max-width: 100%;
  width: 100%;
  .el-input__inner {
    text-align: left !important;
  }
}
.el-input-number__decrease, .el-input-number__increase {
  width: 25px !important;
}
</style>
